import { system } from 'styled-system';
const OBJECT_POSITION_PROPS_TO_CSS_VALUE = {
    left: 'left',
    right: 'right',
    top: 'top',
    topLeft: 'top left',
    topRight: 'top right',
    bottom: 'bottom',
    bottomLeft: 'bottom left',
    bottomRight: 'bottom right',
    center: 'center',
    centerTop: 'center top',
    centerBottom: 'center bottom',
    centerLeft: 'center left',
    centerRight: 'center right',
};
const values = Object.values(OBJECT_POSITION_PROPS_TO_CSS_VALUE);
export const objectPositionValues = [...values];
export function objectPosition() {
    return system({
        objectPosition: {
            property: 'objectPosition',
            transform: (val) => { var _a; return (_a = OBJECT_POSITION_PROPS_TO_CSS_VALUE[val]) !== null && _a !== void 0 ? _a : OBJECT_POSITION_PROPS_TO_CSS_VALUE.center; },
        },
    });
}
//# sourceMappingURL=objectPosition.js.map